import { post } from '../../api';
import { getBirthDateFromAge } from '../../utils/dateFactory';
import config from '../../config/config.json';

const getInsureds = budget => budget.application.petitions[0].insureds;

const getModality = (product, form, isId) => {
  const productConfig = config.products[product];
  if (productConfig.modalitiesInfo) {
    const modalitiesGroup = productConfig.modalitiesInfo.modalitiesGroup;
    for (let i = 0; i < modalitiesGroup.length; i += 1) {
      for (let j = 0; j < modalitiesGroup[i].modalities.length; j += 1) {
        const modality = modalitiesGroup[i].modalities[j];
        if (
          modality.modality === form.selectedModality ||
          modality.modalityName === form.selectedModality
        ) {
          return isId
            ? modalitiesGroup[i].modalities[j].modality
            : modalitiesGroup[i].modalities[j].modalityName;
        }
      }
    }
  }
  return null;
};

const setModality = ({ product, form, budget }) => {
  budget.application.petitions[0].mode = getModality(product, form);
};

const setCoverageRequestData = ({ product, form, budget }) => {
  const addons =
    config.products[product].modalitiesInfo &&
    config.products[product].modalitiesInfo.addons;

  if (addons) {
    for (let i = 0; i < addons.length; i++) {
      if (form[addons[i].id]) {
        budget.application.petitions[0].coverageRequestData = {
          ...budget.application.petitions[0].coverageRequestData,
          [addons[i].id]: 'Si'
        }
      }
    }
  }
};

const calculatorHasAges = form => {
  return form.personNumberSelected !== undefined;
};

const addInsuredsAgesFromBirthDate = (form, budget) => {
  for (let i = 0; i < form.personNumberSelected; i++) {
    getInsureds(budget).push({
      data: {
        birthDate: getBirthDateFromAge(form[`age${i}`])
      }
    });
  }
};

const addPostalCodeToInsureds = (postalCode, budget) => {
  for (let i = 0; i < getInsureds(budget).length; i++) {
    getInsureds(budget)[i].address = {
      cp: postalCode
    };
  }
};

const setInsuredAge = (age, budget) => {
  getInsureds(budget).push({
    data: {
      birthDate: getBirthDateFromAge(age)
    }
  });
};

const setInsuredCoverage = (coverage, budget, position = 0) => {
  getInsureds(budget)[position].coverages = {
    ...getInsureds(budget)[position].coverages,
    ...coverage
  };
};

const addCalculatorFormValues = ({ product, form, budget }) => {
  const calculatorForm = config.products[product].calculator.form;
  calculatorForm.forEach(selectedForm => {
    switch (selectedForm.formName) {
      case 'postalCode':
        addPostalCodeToInsureds(form[selectedForm.formName], budget);
        break;
      case 'age':
        setInsuredAge(form[selectedForm.formName], budget);
        break;
      case 'capital':
        setInsuredCoverage(
          { ImporteAsegurado: form[selectedForm.formName] },
          budget
        );
        break;
      default:
        break;
    }
  });
};

const addCalculatorSelectorValues = ({ product, form, budget }) => {
  const formName = config.products[product].calculator.form.formName;
  let fee = form[formName];
  fee = Number.parseInt(fee, 10) * 100;
  getInsureds(budget).push({});
  setInsuredCoverage({ ImporteAsegurado: fee * 12 }, budget);
  setInsuredCoverage({ ImporteSubsidio: fee }, budget);
  setInsuredCoverage({ SubsidioMensual: fee }, budget);
};

const setInsuredsModalities = ({ product, form, budget }) => {
  const insureds = getInsureds(budget);
  for (let i = 0; i < insureds.length; i++) {
    setInsuredCoverage({ Modalidad: getModality(product, form) }, budget, i);
  }
};

const setSaludData =  ({ product, form, budget }) => {
  budget.application.petitions[0].Relationship = form["relationship"];
}

const setComercioData =  ({ product, form, budget }) => {
  budget.application.petitions[0].CoverageRequestData = form;
}

const setHogarData = ({ product, form, budget }) => {
  budget.application.petitions[0].homeInfo = {
    objectInsured: {
      homeDescrip: {
        EsUnifamiliar: form.singleFamily === '1' ? 'Si' : 'No',
        MetrosConstruidos: form.squareMeters
      }
    },
    guaranties: {
      ContinenteRiesgo: form.risk ? 'Si' : 'No',
      Continente: form.continent
        ? (Number(form.continent) * 100).toString()
        : '0',
      Contenido: form.content ? (Number(form.content) * 100).toString() : '0'
    }
  };
  budget.application.petitions[0].mode = form.selectedProduct === "4" ? 'Hogar' : 'HogarPlus'
};

const constructBudget = ({ ...params }) => {
  const productConfig = config.products[params.product];
  const budget = {
    application: {
      petitions: [
        {
          product: productConfig.id,
          insureds: [],
          RelationshipInsureds: null,
          comercialDetails: { nifPromoter: params.agentId }
        }
      ]
    },
    email: params.email
  };

  if (productConfig.calculator) {
    if (params.product === 'hogar') {
      setHogarData({ ...params, budget });
    }
    else {
      if (params.product === "salud"){
        setSaludData({ ...params, budget });
      }
      setModality({ ...params, budget });
      setCoverageRequestData({ ...params, budget });
      if (calculatorHasAges(params.form)) {
        addInsuredsAgesFromBirthDate(params.form, budget);
      }

      if (productConfig.calculator.type === 'form') {
        addCalculatorFormValues({ ...params, budget });
      }

      if (productConfig.calculator.type === 'selector') {
        addCalculatorSelectorValues({ ...params, budget });
      }

      if (params.form.selectedModality) {
        setInsuredsModalities({ ...params, budget });
      }
    }
  }
  else{
    if (params.product === "comercio")
    {
      setComercioData({ ...params, budget });
    }
  }

  return budget;
};

const sendBudget = (...params) => {
  const budget = constructBudget(...params);
  return post({
    body: budget,
    api: 'api/contract/save'
  });
};

export default sendBudget;
export { constructBudget };



// WEBPACK FOOTER //
// ./src/components/BudgetSender/budget.js